import template from './ko-render-field-list.html';

/**
 * @typedef
 * @name ListInputComponentParamsType
 * @description Input Type for component
 * @type Object
 * @param name
 * @param label
 * @param hide_labels
 * @param {Array | Object} items
 * @param list_label_field
 * @param list_value_field
 * @param {String|Array} options - manual array of options (stringified or actual)
 * @param items_from_cache
 * @param lookup
 */

class ListInputComponentVM
{
	constructor(params)
	{
		this.params = params;

		this.name = ko.observable(params.name);
		this.label = ko.observable(params.label);
		this.hide_labels = ko.observable(params.hide_labels);
		this.$input = ko_helper.safe_observable(params.$input);
		this.help_text = ko.observable(params.help_text);

		this.options = ko.observableArray([]);
		this.optionsText = ko_helper.safe_observable(params.options_text || params.list_label_field, null);
		this.optionsValue = ko_helper.safe_observable(params.options_value || params.list_value_field, null);
		this.optionsCaption = ko_helper.safe_observable(params.caption, 'Select...');
		this.value = ko.observable(this.$input());
		this.size = ko_helper.safe_observable(params.size);

		this.value.subscribe(val => {
			if (!this.optionsValue() && typeof val === 'object')
				this.$input(val);
			else
				this.$input(val);
		});

		this.$input.subscribe(val => {
			if (this.value() !== val)
				this.value(val);
		});

		this.load_options();
	}

	async load_options()
	{
		let rawItems = [];
		let options = this.params.ui_fields?.options;

		// 1. Manual options override
		if (options)
		{
			if (typeof options === 'string')
			{
				try {
					let normalized = options.trim().replace(/'/g, '"');
					rawItems = JSON.parse(normalized);
				} catch (err) {
					console.error('Invalid manual options JSON:', err);
					rawItems = [];
				}
			} else if (Array.isArray(options)) {
				rawItems = options;
			}
		}
		else if (Array.isArray(this.params.items))  // 2. Array passed via `items`
			rawItems = this.params.items;
		else if (this.params.items_from_cache || this.params.ui_fields?.items_from_cache)  // 3. Items from cache
		{
			if (this.params.items_from_cache == 'AllCaches')
			{
				let x = Grape.cache.cache_items || {};
				rawItems = Object.keys(x);
				this.optionsText('text');
				this.optionsValue('value');
			}
			else
			{
				let cache;
				if (this.params.items_from_cache)
					cache = this.params.items_from_cache;
				else
					cache = this.params.ui_fields.items_from_cache;

				try {
					rawItems = await Grape.cache.get(cache);
					
					// Ensure proper text/value fields for cache items
					if (Array.isArray(rawItems) && rawItems.length > 0)
					{
						let first = rawItems[0];
						if (typeof first === 'string' || typeof first === 'number')
						{
							rawItems = rawItems.map(i => ({ text: String(i), value: i }));
							this.optionsText('text');
							this.optionsValue('value');
						}
						else if (typeof first === 'object')
						{
							// Check if name/value fields
							if (first.hasOwnProperty('name') && !this.optionsText())
								this.optionsText('name');

							// Only set optionsValue if specified in params
							if (this.params.options_value || this.params.list_value_field)
							{
								if (first.hasOwnProperty('value'))
									this.optionsValue('value');
							}
							// If no optionsText, find a suitable display field
							if (!this.optionsText())
							{
								let keys = Object.keys(first);
								let stringKey = keys.find(k => typeof first[k] === 'string' || typeof first[k] === 'number');
								if (stringKey)
									this.optionsText(stringKey);
							}
						}
					}
				} catch (err) {
					console.error('Cache error:', err);
					rawItems = [];
				}
			}
		}
		else if (this.params.lookup || this.params.ui_fields?.lookup)  // 4. Lookup
		{
			let res = await Grape.fetches.getJSON('/api/record', {
				schema: 'grape',
				table: 'v_lookup_value',
				filter: [{ field: 'lookup_name', operand: '=', value: this.params.lookup }]
			});
			rawItems = res.records || [];
			if (!this.optionsText())  this.optionsText('name');
			if (!this.optionsValue()) this.optionsValue('lookup_value_id');
		}
		else if (this.params.fetch_items instanceof Function)  // 5. Custom fetch function
			rawItems = await this.params.fetch_items(this) || [];

		// Normalize items array
		let items = [];
		let first = rawItems[0];

		if (typeof first === 'string' || typeof first === 'number')
		{
			items = rawItems.map(i => ({ text: String(i), value: i }));
			this.optionsText('text');
			this.optionsValue('value');
		}
		else if (first && typeof first === 'object')
		{
			items = rawItems;
			if (!this.optionsText())  this.optionsText('name');
		}

		this.options(items);

		let currentValue = this.$input();

		if (currentValue !== undefined)
			this.value(this.options().find(opt => opt.value === currentValue) || currentValue);
	}
}

export default {
	name: 'ko-render-field-list',
	viewModel: ListInputComponentVM,
	module_type: 'ko',
	template: template
};

